@if (showSplash) {
  <div class="app-splash-screen d-flex flex-column justify-content-center align-items-center">
    <div class="app-logo"></div>
    <img
      src="../../../../../assets/loading-indicator/loading-indicator.png"
      class="w-25"
      alt="loading-indicator"
      />
  </div>
}
